import { Injectable } from '@angular/core'
import { environment } from '@employer/environments/environment'
import { BaseReportingConfigProvider, IReportingConfig } from '@engineering11/reporting-web'
import { Store } from '@ngrx/store'
import { getBaseSuffix } from 'shared-lib'
import { selectors } from '../store/selectors'

@Injectable({ providedIn: 'root' })
export class ReportingConfigProvider extends BaseReportingConfigProvider {
  constructor(private store: Store) {
    super()
  }
  get config(): IReportingConfig {
    return {
      reportingBaseURL: environment.services.reporting,
      customerKey$: this.store.select(selectors.getCustomerKey$),
      token$: this.store.select(selectors.getCurrentToken),
      baseSuffix: getBaseSuffix(environment, 'reporting'),
    }
  }
}
